"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const DEFAULT_DEBOUNCE = 2000;
/**
 * @description Immediate debounce. The function execution is performed immediately.
 * Within the stipulated timeout, the remaining events of the same set are ignored.
 * @param {Function} func Function execution to be delayed.
 * @param {number} delay Delay timeout in ms.
 * @returns {Promise<any>}
 */
const debounce = (func, delay = DEFAULT_DEBOUNCE) => {
    let timeout;
    return (...args) => __awaiter(void 0, void 0, void 0, function* () {
        const callNow = !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(() => __awaiter(void 0, void 0, void 0, function* () { timeout = null; }), delay);
        callNow && (yield func(...args));
    });
};
exports.default = debounce;
